/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: API.UserInfoDto } | undefined,
) {
  const { currentUser } = initialState ?? {};
  return {
    /**
     * admin 角色可以访问所有页面
     */
    canAdmin: currentUser && currentUser.rolesName?.includes('admin'),
    /**
     * 项目经理
     */
    isPM: currentUser && currentUser.rolesName?.includes('PM'),
    /**
     * 项目经理的直线经理
     */
    isPMM: currentUser && currentUser.rolesName?.includes('PMManager'),
    /**
     * 生产计划
     */
    isPlanner: currentUser && currentUser.rolesName?.includes('Planner'),
    /**
     * 库房人员
     */
    isWarHouse: currentUser && currentUser.rolesName?.includes('Warehouser'),
    /** 
     * 包装人员
    */
    isPackger: currentUser && currentUser.rolesName?.includes('Packager'),
    /**
     * 产品经理
     */
    isPdtManger: currentUser && currentUser.rolesName?.includes('ProductManager'),
    /**
     * PE
     */
    isPE: currentUser && currentUser.rolesName?.includes('PE'),
    /**
     * AE
     */
    iSAE: currentUser && currentUser.rolesName?.includes('AE'),
    /**
     * Div Controller
     */
    isDController: currentUser && currentUser.rolesName?.includes('DController'),
    /**
     * Div Manager
     */
    isDManager: currentUser && currentUser.rolesName?.includes('DManager'),
    /**
     * SD Sales Manager
     */
    isSDSalesManager: currentUser && currentUser.rolesName?.includes('SDSM'),
  };
}
